


<app-modal-header
  [highlighted]="true"
  (close)="close()">

  <ng-container *ngIf="state.fetchingSessionData$ | async">
    <p-skeleton width="12rem" height="2rem"></p-skeleton>
    <p-skeleton width="7.5rem" height="1rem" class="mt-3 block"></p-skeleton>
  </ng-container>

  <ng-container *ngIf="(state.sessionData$ | async) as sd" slot="title">
    <ng-container *ngIf="!(state.fetchingSessionData$ | async)">
      {{ sd.shopItem.title }}
    </ng-container>
  </ng-container>
  
  <ng-container *ngIf="(state.sessionData$ | async) as sd">
    <ng-container *ngIf="!(state.fetchingSessionData$ | async)">

    <span class="tag mr-2">
      {{ 'admin.attendance.lessons-overview.sessions.session-detail-modal.session-index' | translate:{ index: sd.session.index + 1 } }}
    </span>

    <span *ngIf="sd" class="details-block-wrap text-base">
      <span *ngIf="siHelper.getSessionDayDate(sd.session.startAt) as sDate" class="detail-block">
        {{ sDate | translate }}
      </span>

      <span *ngIf="siHelper.getSessionTimeRange(sd.session.startAt, sd.session.endAt) as sTime" class="detail-block">
        {{ sTime }}
      </span>

      <span *ngIf="siHelper.getSessionLocation(sd.session, true) as sLocation" class="detail-block">
        <span [ngbTooltip]="sLocation" class="text-overflow-ellipsis white-space-nowrap overflow-hidden" style="max-width: 17ch;">
          {{ sLocation }}
        </span>
      </span>
    </span>
    </ng-container>
  </ng-container>

</app-modal-header>

<p-tabView [activeIndex]="activeTab!" (activeIndexChange)="activeTab = $any($event)">
  <p-tabPanel>
    <ng-template pTemplate="header">
      <span>
        {{ 'admin.attendance.lessons-overview.sessions.session-detail-modal.settings-tab.label' | translate }}
      </span>
    </ng-template>
  </p-tabPanel>
  <p-tabPanel >
    <ng-template pTemplate="header">
      <span>
        {{ 'admin.attendance.lessons-overview.sessions.session-detail-modal.participants-tab.label' | translate }}
      </span>
    </ng-template>
  </p-tabPanel>
</p-tabView>

<div class="modal-body">

  <!-- SETTINGS -->
  <ng-container *ngIf="activeTab === SessionCardTab.SETTINGS">
    <ng-container *ngTemplateOutlet="settingsTabEl"></ng-container>
  </ng-container>
  <!-- / -->

  <!-- PARTICIPANTS -->
  <ng-container *ngIf="activeTab === SessionCardTab.PARTICIPANTS">
    <ng-container *ngTemplateOutlet="participantsTabEl"></ng-container>
  </ng-container>
  <!-- / -->


</div>

<div class="modal-footer">

  <!-- SETTINGS footer -->
  <ng-container *ngIf="activeTab === SessionCardTab.SETTINGS">
    <ng-container *ngTemplateOutlet="settingsTabFooterEl"></ng-container>
  </ng-container>
  <!-- / -->

  <!-- PARTICIPANTS footer -->
  <ng-container *ngIf="activeTab === SessionCardTab.PARTICIPANTS">
    <ng-container *ngTemplateOutlet="participantsTabFooterEl"></ng-container>
  </ng-container>
  <!-- / -->

</div>

<ng-template #settingsTabFooterEl>

  <button
    (click)="close()"
    pButton
    label="{{ 'admin.attendance.lessons-overview.sessions.session-detail-modal.cancel-btn.label' | translate }}"
    class="p-button-sm p-button-text p-button-plain flex-1">
  </button>

  <button
    [loading]="!!(state.updatingSessionData$ | async)"
    (click)="onSubmit()"
    pButton
    label="{{ 'admin.attendance.lessons-overview.sessions.session-detail-modal.submit-btn.label' | translate }}"
    class="p-button-sm flex-1">
  </button>
</ng-template>

<ng-template #settingsTabEl>

  <ng-container *ngIf="state.fetchingSessionData$ | async; else fetched">
    <div class="flex justify-content-center align-items-center">
      <p-progressSpinner></p-progressSpinner>
    </div>
  </ng-container>

  <ng-template #fetched>

    <ng-container [formGroup]="form" *ngIf="sessionCardData as sd">
      <div class="grid pt-3">

        <div class="col-12">
          <div class="p-float-label">
            <input type="text" pInputText formControlName="title" class="w-full">
            <label>{{ 'admin.attendance.lessons-overview.sessions.session-detail-modal.session-title.label' | translate }}</label>
          </div>
        </div>
  
        @if (form.value.format === SessionFormat.ONLINE) {
          <div class="flex align-items-center justify-content-between col-12">
            
            <app-start-at-end-at-input [FG]="form.controls.dates" [whisperValues]="(selectedOrg.selectedOrg$ | async)?.sessionTimeFromToWhisperValues"></app-start-at-end-at-input>
  
          </div>
        }

        @if (form.value.format === SessionFormat.ONSITE) {
          <div class="col-12">
            <div
              (click)="onLocationDropdownClick()"
              class="p-inputtext flex align-items-center gap-3 cursor-pointer"
            >
              <div>
                <div class="mb-1">
                  @if (selectedLocation) {
                    {{ selectedLocation.internalTitle || selectedLocation.title }}
                  } @else {
                    <span class="text-red-500">
                      {{ 'admin.attendance.lessons-overview.sessions.session-detail-modal.location.empty' | translate }}
                    </span>
                  }
                </div>
                <div class="flex align-items-start">
                  <span class="text-bluegray-400" style="white-space: break-spaces;">
                    <!-- :undefined:'UTC+0' not used on purpose - its correct (atleast for now :-) )-->
                    <span class="capitalize">{{ form.value.dates?.startAt | localizedDate:'cccccc' }}</span> {{ form.value.dates?.startAt | localizedDate:'shortDate' }} {{ form.value.dates?.startAtTime }}
                    -
                    {{ form.value.dates?.endAtTime }} <span class="capitalize">{{ form.value.dates?.endAt | localizedDate:'cccccc' }}</span> {{ form.value.dates?.endAt | localizedDate:'shortDate' }}
                  </span>
                </div>
              </div>
              <div style="display: flex; justify-content: flex-end; flex: auto;">
                <div class="text-bluegray-400" style="display: flex; align-items: center; flex-direction: column;">
                  <i class="pi pi-sort-alt rotate-90 text-400"></i>
                  <span class="text-sm">
                    {{ 'admin.attendance.lessons-overview.sessions.session-detail-modal.location.change' | translate }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        }
        
  
        <div class="col-12 flex justify-content-between align-items-center">
          <p-selectButton [options]="formatOptions" formControlName="format" optionLabel="label" optionValue="value">
            <ng-template let-item pTemplate>
              <!-- <i *ngIf="form.controls.format.value === item.value" class="pi pi-check mr-2"></i> -->
              <span>
                {{ item.label | translate }}
              </span>
            </ng-template>
          </p-selectButton>

          <div class="flex" style="flex: 0;">
            <p-inputGroup class="time-allocation" [ngbTooltip]="'admin.attendance.lessons-overview.sessions.session-detail-modal.time-allocation-input.tooltip' | translate">
              <p-inputNumber
                (click)="onTimesCntInputClick($event, timesCntMenu)"
                [minFractionDigits]="0"
                [maxFractionDigits]="2"
                formControlName="timesCnt"
                >
              </p-inputNumber>
              <p-menu #timesCntMenu [model]="timesCntMenuItems" [autofocus]="false" appendTo="body" [baseZIndex]="999999999999" [popup]="true"></p-menu>
              <p-inputGroupAddon>
                &#215;
              </p-inputGroupAddon>
              <p-dropdown
                [options]="hourDurationOptions"
                (onChange)="onHourDurationChange($event)"
                formControlName="hourDuration">
              </p-dropdown>
            </p-inputGroup>
          </div>
        </div>

        <div *ngIf="form.controls.meetingUrl" class="col-12">
          <input pInputText formControlName="meetingUrl" placeholder="{{ 'admin.attendance.lessons-overview.sessions.session-detail-modal.meeting-url.placeholder' | translate }}" class="w-full" id="format">
          <!-- <label for="format">Odkaz</label> -->
        </div>

        <div class="field col-12">
          <span class="p-float-label w-full">
            <p-chips
              #sessionLecturerAttendanceTagsChips
              formControlName="sessionLecturerAttendanceTags"
              id="sessionLecturerAttendanceTags"
              styleClass="w-full"
              class="w-full"
              inputStyleClass="w-full"
              separator=","
              [allowDuplicate]="false"
              (onBlur)="onChipsInputBlur($event, sessionLecturerAttendanceTagsChips)"
              [style]="{width:'100%'}">
            </p-chips>
            <label for="sessionLecturerAttendanceTags">{{ 'admin.shop-item.form-section.advanced-settings.session-lecturer-attendance-tags-input.label' | translate }}</label>
          </span>
        </div>
        
      </div>
  
  
      <!-- TEAM -->
  
      <div class="flex flex-column">
        <div class="flex justify-content-between align-items-center -mb-2 ">
          <h3 class="text-base">
            {{ 'admin.attendance.lessons-overview.sessions.session-detail-modal.team' | translate }}
          </h3>

          <div class="flex">
            <button
              (click)="teamActionMenu.toggle($event)"
              pButton
              [ngbTooltip]="'admin.attendance.lessons-overview.sessions.session-detail-modal.team.add-team-member-btn.tooltip' | translate"
              [disabled]="!!sd?.session?.lecturerAttendanceClosed"
              icon="pi pi-user-plus"
              class="p-button-rounded p-button-text p-button-plain">
            </button>
            <p-menu #teamActionMenu [popup]="true" [model]="teamMenuItems" appendTo="body" [baseZIndex]="1000000000"></p-menu>

          </div>

        </div>

        <ng-container *ngTemplateOutlet="dividerEl"></ng-container>
    
        <table class="lecturers-table block overflow-x-auto white-space-nowrap compensate-modal-body-x-padding">
          @for (control of form.controls.lecturers.controls; let i = $index; let first = $first; track control.value) {
            <tr [class.loading-box]="updatingLecturers.includes(control.value.id!)">
              <ng-container *ngIf="getLecturerById(control.controls.lecturerId.value) as lecturer" [formGroup]="control">
        
                <!-- <div class="flex justify-content-between align-items-center column-gap-2 flex-wrap"> -->
        
                  <td class="table-col-min-width">
                    <app-lecturer-avatar-name [lecturer]="lecturer" [locketOrgId]="sd.shopItem.organizationId" class="content-user"></app-lecturer-avatar-name>
                  </td>
        
                  <td>
                    <div class="flex column-gap-1">
    
                      <div class="flex flex-column">
                        <span class="tag">
                          <ng-container *ngIf="control.controls.type.value === SessionLecturerType.SUBSTITUTION">
                            {{ 'admin.attendance.lessons-overview.sessions.session-detail-modal.substituting' | translate }}
                          </ng-container>
                          {{ 'admin.attendance.lessons-overview.sessions.session-detail-modal.lecturer' | translate }}
                        </span>
                        <p (click)="onLecturerHourRate(control)" class="m-0 text-xs cursor-pointer hover:underline">
                          <ng-container *ngIf="(control.controls.hourRate.value.value | typeof) === 'number'; else notNumber">
                            {{ 'admin.attendance.lessons-overview.sessions.session-detail-modal.hour-rate' | translate:{ hourRate: [$any(control.controls.hourRate.value)] | price | async } }}
                          </ng-container>
                          <ng-template #notNumber>
                            {{ 'admin.attendance.lessons-overview.sessions.session-detail-modal.hour-rate-missing' | translate }}
                          </ng-template>
                        </p>
                      </div>
  
                      <app-warning-icon
                        (click)="onSessionLecturerWarningEnabledToggle(control.controls.warningEnabled)"
                        [style]="control.controls.warningEnabled.value ? WarningIconStyle.FILLED : WarningIconStyle.OUTLINED"
                        *ngIf="control.controls.hourRate.controls.value.value === null || hasConflict(sd, lecturer.id)"
                        [ngbTooltip]="warningIconTooltip"
                        class="cursor-pointer">
                      </app-warning-icon>
                      <ng-template #warningIconTooltip>
                        <span class="text-left">
                          <p *ngIf="hasConflict(sd, lecturer.id)">
                            <b>{{ 'admin.attendance.lessons-overview.sessions.session-detail-modal.attendance-error' | translate }}</b>
                            <br>
                            <i>{{ getLecturerConflictTooltip(sd, lecturer) }}</i>
                          </p>
                          <p *ngIf="control.controls.hourRate.controls.value.value === null">
                            <b>{{ 'admin.attendance.lessons-overview.sessions.session-detail-modal.hourrate-error' | translate }}</b>
                          </p>
                        </span>
                      </ng-template>
  
                    </div>
                  </td>
    
    
                  <!-- spacer -->
                  <td class="w-full">
                  </td>
    
                  <!-- <app-hour-rate-fg [fg]="form.controls.lecturers.controls[i].controls.hourRate" [appendTo]="null" class="inputs-hour-rate"></app-hour-rate-fg> -->
      
                  <td>
                    <app-select-button-colored
                      [options]="stateOptions"
                      [nullValueTooltip]="'admin.attendance.lessons-overview.sessions.session-detail-modal.attendance-missing.tooltip' | translate"
                      formControlName="state"
                      class="inputs-attendance flex-shrink-0">
                    </app-select-button-colored>
                  </td>
        
    
                  <td>
                    <div #asd class="content-menu">
                      <button [disabled]="sd.session.lecturerAttendanceClosed" (click)="itemMenu.toggle($event); memberMenuItemIndex = i;" pButton pRipple type="button" icon="pi pi-ellipsis-h" class="p-button-text p-button-plain p-button-rounded flex-shrink-0"></button>
                      <p-menu #itemMenu [popup]="true" [model]="memberMenuItems" appendTo="body" [baseZIndex]="1000000000"></p-menu>
                    </div>
                  </td>
        
                <!-- </div> -->
        
              </ng-container>
            </tr>

          }
        </table>
    
      </div>
  
      <!-- / team -->
    
    </ng-container>

  </ng-template>

</ng-template>


<ng-template #participantsTabFooterEl>

  @if (siHelper.getIsAttendanceModuleEnabled(sessionCardData?.shopItem?.settingModules ?? null)) {
    <button
      [loading]="preparingAttendancePdfDownload"
      (click)="onDownloadAttendancePdf()"
      pButton
      icon="pi pi-download"
      label="{{ 'admin.attendance.lessons-overview.sessions.session-detail-modal.download-attendance-document-btn.label' | translate }}"
      class="p-button-sm">
    </button>
  }
</ng-template>

<ng-template #participantsTabEl>

  <app-session-attendance [sessionUuid]="sessionUuid"></app-session-attendance>

</ng-template>


<ng-template #dividerEl>
  <div class="divider"></div>
</ng-template>